import * as React from "react";
import { useQueryClient, type QueryClient } from "@tanstack/react-query";

function useWidgetsInvalidator() {
  let queryClient: QueryClient;
  try {
    queryClient = useQueryClient();
  } catch {
    throw Error(
      "useWidgetsInvalidation must be used within the `WorkOsWidgets` provider component",
    );
  }

  return React.useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: ["authToken"] });
    // TODO: Unclear why, but invalidating other widgets' queries immediately
    // after the authToken invalidation (even though it's async?) doesn't work,
    // and We end up with stale data. Waiting for the next tick fixes this.
    await new Promise((resolve) => setTimeout(resolve, 1));
    return queryClient.invalidateQueries({
      predicate: (query) =>
        query.queryKey.some(
          (key) => typeof key === "string" && key.startsWith("/_widgets/"),
        ),
    });
  }, [queryClient]);
}

export { useWidgetsInvalidator as unstable_useWidgetsInvalidator };
